// import {
//   SOME_MUTATION
// } from './mutation-types'

const mutations = {}

export default mutations
